/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const investment_account = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.983 7.315c-.394-.43-.818-.819-1.235-1.148h-3.72C5.556 7.327 4 9.228 4 11.084 4 13.483 5.053 14.832 8.19 15c1.997 0 3.236-.116 3.968-.66M13 9.79l-2.471 2.61a.484.484 0 0 1-.65.057l-1.107-.835a.486.486 0 0 0-.609.017l-.909.915M13 9.79h-2.017m2.017 0v2.13M11.914 1l-5.586.983s.93.537.93 1.967h3.026c0-1.43 1.63-2.95 1.63-2.95Z"
    />
  </svg>
)
export default investment_account
